export default {
    computed: {
        paginationOptions() {
            return {
                enabled: this.rows.length >= 50,
                perPage: 50,
                perPageDropdown: [50, 100, 250, 500, 1000],
                dropdownAllowAll: false,
            }
        },
    },
}
